import React, { useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Checkout from '../../components/checkout/Checkout';
import { businessRegistrationInitiate } from '../../redux/actions/register';

import '../paymentForm/payment.css';
import logo from '../../assests/images/logo.png'
import { useNavigate } from 'react-router-dom';
import Logo from '../../components/logoHolder/Logo';

const Register = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()

  const [name, setName ] = useState('');
  const [email, setEmail] = useState('');
  const [phonenumber, setPhonenumber] = useState('');
  const [amount, setAmount] = useState('');
  const [selected, setSelected] = useState('');

//   const updatePrice = () => {
//       if(selected === "State Govt"){
//           setAmount()
//         }
//         else if(selected === "Federal Govt"){
//             setAmount(500000)
//         }else{
//             setAmount(0)
//         }
//         console.log(selected)
//         console.log("Hello from here")
//  }

const handleChange = (e) => {
    setEmail(e.target.value);
    setAmount(e.target.value);
    setName(e.target.value);
    setPhonenumber(e.target.value);
    setSelected(e.target.value);
}

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(name, phonenumber, email, selected, amount)
        await dispatch(businessRegistrationInitiate(name, phonenumber, email, selected, amount))
        setEmail('')
        setAmount('')
        setName('')
        setPhonenumber('')
        setSelected('')
        
        }

  return (
        <div className='born-again-wrapper-form'>
        <div className="inner-wrapper">
            <div className="header-born-again">
               <Logo />
            </div>
            <div className="confession-text">
                <p>Register for Business and Investment forum</p>
            </div>
            <form className="form-to-fill" onSubmit={handleSubmit}>
                <input 
                type="text"
                className='top-input'
                placeholder='Full Name'
                id='fname'
                name='fname'
                value= {name}
                onChange={(e) => setName(e.target.value)}
                required
                />
                <input 
                type="text"
                className='down-input'
                placeholder='Email'
                id='email'
                name='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                />
                <input type="text"
                className='down-input'
                placeholder='Phone Number'
                id='phone'
                name='phone'
                value= {phonenumber}
                onChange={(e) => setPhonenumber(e.target.value)}
                required
                />
                <input 
                type="text"
                className='down-input color-nominee'
                placeholder='Amount'
                id='amount'
                name='Amount'
                value= {amount}
                onChange={(e) => setAmount(e.target.value)}
                required
                />
                <select
                sx={{ backgroundColor:'red' }}
                name='selection'
                defaultValue={{ label: "Select an option", value: 0 }}
                className='selected-input'
                value={selected}
                onChange={(e) =>  setSelected(e.target.value)}
                >
                    <option value='default'>Select an option</option>
                    <option value='State Govt'>State Govt.  - N1,500,000</option>
                    <option value='Federal Govt'>Federal Govt. Ministries (3 person) - N500,000</option>
                    <option value="Private Companies">Private Companies (3 person) - N500,000</option>
                    <option value="Private Organization">Private Organization (3 person) - N500,000</option>
                    <option value="MSMEs/Entrepreneur">MSMEs/Entrepreneur (3 person) - N220,000</option>
                    <option value="Academician/Student">Academician/Student - Free</option>
                </select>
                <Checkout selected={selected} amount={amount} email={email} phone={phonenumber} name={name} logo={logo} />
            </form>
        </div>
    </div>
  )
}

export default Register